__turbopack_context__.v({
  "blurredNotificationImg": "Steps-module__Vcc_CW__blurredNotificationImg",
  "btnLink": "Steps-module__Vcc_CW__btnLink",
  "buttons": "Steps-module__Vcc_CW__buttons",
  "container": "Steps-module__Vcc_CW__container",
  "content": "Steps-module__Vcc_CW__content",
  "img": "Steps-module__Vcc_CW__img",
  "linkArrow": "Steps-module__Vcc_CW__linkArrow",
  "subContainer": "Steps-module__Vcc_CW__subContainer",
  "title": "Steps-module__Vcc_CW__title",
});
